// extracted by mini-css-extract-plugin
export default {"toolbar":"RoomsTab_toolbar__AGE77","table":"RoomsTab_table__C-1Lk","smallBtn":"RoomsTab_smallBtn__Pbsxo","full":"RoomsTab_full__utqDk","free":"RoomsTab_free__9R+Yg"};